import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import MSnackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const styles = theme => ({
  close: {
    width: theme.spacing(4),
    height: theme.spacing(4)
  }
});

class Snackbar extends React.Component {
  render() {
    const { classes, isOpen, handleClose, actions, message } = this.props;
    return (
      <MSnackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        open={isOpen}
        autoHideDuration={5000}
        onClose={handleClose}
        ContentProps={{
          "aria-describedby": "message-id"
        }}
        message={<span id="message-id">{message}</span>}
        action={actions.concat(
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        )}
      />
    );
  }
}

Snackbar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  actions: PropTypes.array.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default withStyles(styles)(Snackbar);



// WEBPACK FOOTER //
// ./src/components/Snackbar.js